import React, { forwardRef, useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { GridActionsCellItem } from "@mui/x-data-grid";
import * as Icons from "react-bootstrap-icons";
import MButton from "Utils/Helpers/MButton";
import DataGridComponent from "Utils/Constants/DataGridComponent";
import { subRoadmapList } from "Utils/Helpers/TableColumns";
import { useSelector } from "react-redux";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function SubCategoriesShow({ cell, row }) {
  const [show, setShow] = useState(false);
  const [data, setData] = useState(false);
  const { roadmap } = useSelector((state) => ({
    roadmap: state.mngr.roadmap,
  }));

  const onEnter = () => {
    setData(row.subCategory);
  };

  useEffect(() => {
    if (roadmap) {
      setShow(false);
    }
  }, [roadmap]);

  const setShowDialog = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <>
      <GridActionsCellItem
        icon={<Icons.ThreeDotsVertical size={16} />}
        label="SubCategories"
        onClick={setShowDialog}
        className={`btn-manager ${
          row.subCount === 0 ? "btn-disabled" : "btn-primary"
        }`}
        disabled={row.subCount === 0}
      />
      {show && (
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={"md"}
          onClose={handleClose}
          TransitionProps={{ onEnter: onEnter }}
          aria-describedby="alert-dialog-edit"
        >
          <DialogTitle>{`Edit (${row.title})`}</DialogTitle>
          <DialogContent>
            {show && <DataGridComponent data={data} columns={subRoadmapList} />}
          </DialogContent>
          <DialogActions>
            <MButton label={"Close"} color="secondary" onClick={handleClose} />
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
